<template>
    <form
        class="form-vertical authentication-email"
        @submit.prevent="loginByEmail"
    >
        <div
            v-for="input in authData.authInputs"
        >
            <def-email
                v-if="input.type !== 'hidden' && input.type === 'text'"
                :required="input.type !== 'hidden'"
                :label="messages.email"
                :name="input.name"
                :type="input.type"
                :value="emailValue ? emailValue : input.value"
                :error="input.error"
                @input="getTargetValue"

            />
            <def-input
                v-else-if="input.type !== 'hidden'"
                :required="input.type !== 'hidden'"
                :label="input.placeholder"
                :name="input.name"
                type="password"
                :value="input.value"
                :error="input.error"
            />
            <input v-else type="hidden" :name="input.name" :value="input.value">
        </div>

        <enter-cabinet-main-btn
            :btnValues="messages.sign_in"
        />
    </form>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: 'authentication-email',
    selector: '.authentication-email',
    data(){
        return{
            emailValue: '',
        }
    },
    computed: {
        ...mapState({
            authData: ({ personal }) => personal.data,
            messages: ({ personal }) => personal.data.messages,
            btnValues: ({ personal }) => personal.data.btnValues,
            errors: ({ personal }) => personal.data.errors,
        }),
    },
    methods: {
        getTargetValue(value){
            if (value instanceof Event) {
                this.emailValue = value.target.value;
            } else {
                this.emailValue = value;
            }
        },
        ...mapActions({
            loginByEmail: 'personal/loginByEmail',
        })
    }
}
</script>

<style lang="scss" scoped>
.authentication-email{

}
</style>